import React from 'react';

const CourierDetailsForm = ({handleChange, onSubmit, values}) => (
  <form>
    <div className="form-group">
        <input
            type="text"
            onChange={handleChange('courierWaybillId')}
            placeholder="No Resi"
            className="form-control"
            values={values.courierWaybillId}
        />
    </div>
  </form>
)


export default CourierDetailsForm
